import React from 'react'
import {Pill} from 'elements/PillList'
import cs from 'classnames'
import styles from 'elements/Banner.scss'

const Banner = ({bold, beforeLink, button, afterLink, link, destination, onClick, className}) => {
	return (
		<div className={cs(styles.mainCon, className)}>
			<div className={styles.xButton}></div>
			<div className={styles.textCon}>
				{bold && <strong>{bold}: </strong>}
				{beforeLink && <span>{beforeLink} </span>}
				{destination && link && <a target="_new" href={destination}>{link}</a>}
				{afterLink && <span> {afterLink}</span>}
			</div>
			{button && <Pill>
				<div
					className={styles.xButton}
					onClick={onClick}
				>
					{button}
				</div>
			</Pill>}
		</div>
	)
}
export default Banner



// WEBPACK FOOTER //
// ./elements/Banner.jsx